export const CUSTOM_FIELD_IDS = Object.freeze({
  loanPurpose: "kxBSmTobF1HNoBFrY496",
  loanType: "AWfzsE12vIzsEgy6j8Ii",
  loanAmount: "sTRJxmwKNx2ctwKiG5P0",
  propertyAddress: "YKJWbJWyd67bCcutqO6X",
  unitType: "ZlYSYHw691X4tsKHiV6k",
  note: "l6Mf612VeKNXPvoQYsGF",
  ltv: "OqUBaYzKwcqH3AWOsoWI",
  ltc: "smZAK02klqVP3he7yngm",
  documents: "MgL7n0y2VZetz9T0U0PI",
  creditScore: "PqlxFCaGc930dUplcWOn",
}); 